<!-- 中型弹窗，常规列表 -->
<template>
  <StdDialog
    :visible.sync="dialogVisible"
    title="选择奖励"
    size="medium"
    :loading="loading"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- NOTE: 自定义标题: 开发人员根据业务调整 -->
    <template slot="title">
      <StdBackHeader :showBack="false">
        <template slot="content">
          选择奖励
          <span class="title-tips">
            提示：需要完成对接后才能选择内容
            <a class="link" href="" target="_blank">查看接口文档</a>
          </span>
        </template>
      </StdBackHeader>
    </template>

    <!-- 内容区 -->
    <!-- NOTE: 空数据情况: 开发人员根据业务调整 -->
    <template v-if="isNoData">
      <StdNullPage text="暂无数据" :nullType="'nullData'"></StdNullPage>
    </template>

    <!-- 非空数据情况 -->
    <template v-if="!isNoData">
      <!-- NOTE: 搜索栏: 开发人员根据业务调整  -->
      <StdSearchBar v-model="keyword" @search="handleSearch"></StdSearchBar>

      <!-- NOTE: 表格数据: 开发人员根据业务调整  -->
      <vh-table
        ref="tableRef"
        :data="dataList"
        style="width: 100%"
        height="360px"
        class="reward-table"
        v-loadMore="loadMore"
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <StdNullPage text="暂未搜索到您想要的内容" :nullType="'search'"></StdNullPage>
        </template>
        <!-- 多选 -->
        <vh-table-column type="selection" :selectable="selectable" width="60" />
        <vh-table-column prop="id" label="ID" width="60" />
        <vh-table-column prop="title" label="标题" min-width="160">
          <template slot-scope="scope">
            <vh-tooltip effect="dark" placement="top-start" :content="scope.row.title">
              <div class="custom-tooltip-content">
                {{ scope.row.title }}
              </div>
            </vh-tooltip>
          </template>
        </vh-table-column>
        <vh-table-column prop="award_type" label="类型" width="80"></vh-table-column>
        <vh-table-column label="其他说明" width="140">
          <template slot-scope="scope">
            <vh-tooltip effect="dark" placement="top-start" :content="scope.row.remark">
              <div class="custom-tooltip-content">
                {{ scope.row.remark }}
              </div>
            </vh-tooltip>
          </template>
        </vh-table-column>
      </vh-table>
    </template>
    <!-- 底部操作栏 -->
    <!-- NOTE: 底部操作栏: 开发人员根据业务调整 -->
    <div slot="footer" class="dialog-footer" v-if="!isNoData">
      <div class="dialog-footer__hd">
        <div class="text-regular-8" style="display: inline; text-align: left">
          已选择
          <span class="fc-red">{{ multipleSelection.length }}</span>
          /10
        </div>
      </div>
      <div class="dialog-footer__bd">
        <vh-button round type="info" size="medium" plain @click="dialogVisible = false">
          取消
        </vh-button>
        <vh-button round type="primary" size="medium" @click="submitForm()">确定</vh-button>
      </div>
    </div>
  </StdDialog>
</template>
<script>
  import { StdSearchBar, StdDialog, StdBackHeader, StdNullPage } from '@vhcl/ui-console';
  import { getAwardList } from '../../common/api';
  export default {
    components: { StdSearchBar, StdDialog, StdBackHeader, StdNullPage },
    props: {
      selected: {
        type: Array,
        default: () => []
      }
    },
    name: 'DialogList',
    data() {
      return {
        isNoData: true,
        loading: false,
        keyword: '',
        multipleSelection: [],
        dataList: [],
        total: 0, // 总数量
        // 分页参数
        pagination: {
          limit: 50,
          pageNo: 1
        },
        dialogVisible: false
      };
    },
    methods: {
      openDialog() {
        this.keyword = '';
        this.dialogVisible = true;
        this.multipleSelection = this.selected ? [...this.selected] : [];
        this.handleSearch();
      },
      selectable(row) {
        return !this.selected.some(item => item.id === row.id);
      },
      handleSelectionChange(val) {
        const merged = [...this.selected];
        for (const item of val) {
          if (!merged.find(existingItem => existingItem.id === item.id)) {
            merged.push(item);
          }
        }
        this.multipleSelection = merged;
      },
      handleSearch() {
        this.pagination.pageNo = 1;
        this.fetchData();
      },
      loadMore() {
        if (this.dataList.length >= this.total && this.total > 0) return;
        console.log('---loadMore---');
        this.fetchData();
      },
      // 模拟请求数据
      fetchData: async function () {
        getAwardList({
          keyword: this.keyword.trim(),
          pos: (this.pagination.pageNo - 1) * this.pagination.limit,
          limit: this.pagination.limit
        }).then(res => {
          const { data } = res;
          this.total = data.total;
          if (this.pagination.pageNo === 1) {
            this.dataList = data.list;
          } else {
            this.dataList = this.dataList.concat(data.list);
          }
          const selectedIds = this.multipleSelection.map(item => item.id);
          setTimeout(() => {
            this.dataList.forEach(row => {
              if (selectedIds.includes(row.id)) {
                this.$refs.tableRef.toggleRowSelection(row, true);
              }
            });
          }, 50);

          this.pagination.pageNo++;
          this.isNoData = !this.keyword.trim() && this.dataList.length === 0;
        });
      },
      submitForm() {
        if (this.multipleSelection.length > 10) {
          this.$message.error('最多选择10个');
        } else {
          this.dialogVisible = false;
          this.$emit('onSelected', this.multipleSelection);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .title-tips {
    font-size: 12px;
    color: #999;
    margin-left: 10px;
    vertical-align: middle;
  }
  .reward-table {
    /deep/.vh-table__header-wrapper {
      .vh-checkbox {
        display: none;
      }
    }
  }
</style>
